<template>
    <ul
        class="l-ss-c-enum-tree-wrapper"
        :class="[`l-ss-c-enum-tree-wrapper-level-${level}`]">
        <tree-enum-node
            v-for="node in nodeOptions"
            v-model="activeCategories"
            :key="node.id"
            :node="node">
            <template #default="{ isOpen }">
                <tree-enum-nodes
                    v-if="node.hasVisibleChild && isOpen"
                    v-model="activeCategories"
                    :options="node.child"
                    :level="level + 1"/>
            </template>
        </tree-enum-node>
    </ul>
</template>

<script>
    import { computed } from '@vue/composition-api';

    import TreeEnumNode from '@/core/components/common/filters/filter-types/tree-enum/tree-enum-node.vue';

    export default {
        name: 'tree-enum-nodes',
        components: { TreeEnumNode },
        model: {
            prop: 'value',
            event: 'change',
        },
        props: {
            value: {
                type: Set,
            },
            options: {
                type: Array,
            },
            level: {
                type: Number,
            },
        },
        setup(props, { emit }) {
            const activeCategories = computed({
                get() {
                    return props.value;
                },
                set(value) {
                    emit('change', value);
                },
            });

            const nodeOptions = computed(() => {
                let filteredOptions = props.options.filter((option) => !option.hidden);

                if (activeCategories.value.size) {
                    const selectedIndexMap = new Map(Array.from(activeCategories.value, (activeCategoryId, i) => [activeCategoryId, i]));

                    return filteredOptions.sort((a, b) => {
                        let indexA = selectedIndexMap.get(a.id);
                        let indexB = selectedIndexMap.get(b.id);

                        if (indexA === undefined) {
                            indexA = Infinity;
                        }

                        if (indexB === undefined) {
                            indexB = Infinity;
                        }

                        return indexA - indexB;
                    });
                }

                return filteredOptions;
            });

            return {
                activeCategories,
                nodeOptions,
            };
        },
    };
</script>

<style scoped>

</style>
